import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PersonalHearingService } from '../../service/personalHearing.service';
import { PhFeedbackModel } from '../../model/masters/phFeedback.model';
import { NotificationService } from '../../service/notification.service';

@Component({
  selector: 'dda-ph-feedback',
  templateUrl: './ph-feedback.component.html',
  styleUrls: ['./ph-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhFeedbackComponent implements OnInit {
  appointmentId: string = '';
  feedback: string = '';
  officerName: string = '';

  constructor(private personalHearingService: PersonalHearingService, private notificationService: NotificationService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    const feedbackModel: PhFeedbackModel = {
      appointmentId: this.appointmentId,
      officerName: this.officerName,
      feedback: this.feedback,
      id: 0
    };

    this.personalHearingService.saveFeedback(feedbackModel).subscribe({
      next: (response) => {

        this.notificationService.success('Feedback is registered successfully hope to see you again!!');
        console.log('Feedback saved successfully:', response);


        this.appointmentId = '';
        this.officerName = '';
        this.feedback = '';


        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      error: (error) => {
        console.error('Error saving feedback:', error);
      }
    });
  }


}
